import { render, staticRenderFns } from "./FrLinks.vue?vue&type=template&id=8846a690&"
import script from "./FrLinks.vue?vue&type=script&lang=js&"
export * from "./FrLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports